
import { useState } from "react";
import { Box, Plus, BarcodeIcon, ShoppingBasket, FileText, Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import AddItemModalWrapper from "@/components/inventory/AddItem/AddItemModalWrapper";

const EmptyInventoryState = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<string>("manual");
  
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="bg-gray-100 p-6 rounded-full mb-6">
        <ShoppingBasket className="h-12 w-12 text-expitrack-primary" />
      </div>
      
      <h2 className="text-2xl font-semibold mb-3">Your inventory is empty</h2>
      <p className="text-gray-500 max-w-md mb-8">
        Start tracking your inventory by adding items. You can add items manually, 
        scan barcodes, take photos, or import from receipts.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 max-w-3xl">
        <Button 
          variant="outline" 
          className="flex flex-col items-center py-6 h-auto"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <Plus className="h-8 w-8 mb-2" />
          <span className="text-sm font-medium">Add Manually</span>
        </Button>
        
        <Button 
          variant="outline" 
          className="flex flex-col items-center py-6 h-auto"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <BarcodeIcon className="h-8 w-8 mb-2" />
          <span className="text-sm font-medium">Scan Barcode</span>
        </Button>
        
        <Button 
          variant="outline" 
          className="flex flex-col items-center py-6 h-auto"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <Camera className="h-8 w-8 mb-2" />
          <span className="text-sm font-medium">Take Photo</span>
        </Button>
        
        <Button 
          variant="outline" 
          className="flex flex-col items-center py-6 h-auto"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <FileText className="h-8 w-8 mb-2" />
          <span className="text-sm font-medium">Scan Receipt</span>
        </Button>
      </div>
      
      <AddItemModalWrapper 
        open={isModalOpen} 
        onOpenChange={setIsModalOpen} 
        onItemAdded={() => {
          toast.success("Item added to inventory");
        }}
      />
    </div>
  );
};

export default EmptyInventoryState;
